import { Component } from '@angular/core';
import * as moment from 'moment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [TranslateModule],
})
export class FooterComponent {
    year: string = moment().format('yyyy');
}
